import { Building2, Copy, MapPin, Truck } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export const EMPTY_ADDRESS = { line1: "", line2: "", city: "", state: "", pin: "", country: "India" };

export function addressFromParty(party, kind = "billing") {
  const key = kind === "shipping" ? "shipping_address_details" : "billing_address_details";
  const legacy = kind === "shipping" ? party?.shipping_address : party?.billing_address;
  const d = party?.[key];
  if (d && typeof d === "object") return { ...EMPTY_ADDRESS, ...d };
  return {
    ...EMPTY_ADDRESS,
    line1: legacy || "",
    city: party?.city || "",
    state: party?.state || "",
    pin: party?.pin || "",
    country: party?.country || "India",
  };
}

export function addressText(a) {
  if (!a) return "";
  return [a.line1, a.line2, a.city, a.state, a.pin, a.country].filter(Boolean).join(", ");
}

export default function AddressFields({ title, value, onChange, icon = "billing", copyLabel, onCopy, compact = false }) {
  const set = (k, v) => onChange({ ...(value || EMPTY_ADDRESS), [k]: v });
  const Icon = icon === "shipping" ? Truck : Building2;
  return (
    <div className="rounded-xl border border-slate-200 dark:border-slate-800 p-4 bg-slate-50/50 dark:bg-slate-800/20">
      <div className="flex items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2">
          <Icon className="h-4 w-4 text-slate-700 dark:text-slate-300" />
          <h3 className="font-semibold text-sm">{title}</h3>
        </div>
        {onCopy && <Button type="button" size="sm" variant="outline" className="h-8 text-xs" onClick={onCopy}><Copy className="mr-1 h-3.5 w-3.5" />{copyLabel || "Copy Address"}</Button>}
      </div>
      <div className={`grid grid-cols-1 ${compact ? "sm:grid-cols-2" : "sm:grid-cols-2"} gap-3`}>
        <div><Label>Address Line 1 *</Label><Input className="mt-1.5" value={value?.line1 || ""} onChange={(e) => set("line1", e.target.value)} placeholder="House / Flat / Building / Street" /></div>
        <div><Label>Address Line 2</Label><Input className="mt-1.5" value={value?.line2 || ""} onChange={(e) => set("line2", e.target.value)} placeholder="Area / Landmark" /></div>
        <div><Label>City *</Label><Input className="mt-1.5" value={value?.city || ""} onChange={(e) => set("city", e.target.value)} placeholder="City" /></div>
        <div><Label>State *</Label><Input className="mt-1.5" value={value?.state || ""} onChange={(e) => set("state", e.target.value)} placeholder="State" /></div>
        <div><Label>PIN Code *</Label><Input inputMode="numeric" maxLength={6} className="mt-1.5" value={value?.pin || ""} onChange={(e) => set("pin", e.target.value.replace(/\D/g, "").slice(0, 6))} placeholder="PIN Code" /></div>
        <div><Label>Country</Label><Input className="mt-1.5" value={value?.country || "India"} onChange={(e) => set("country", e.target.value)} placeholder="Country" /></div>
      </div>
      <p className="mt-2 text-[11px] text-slate-400 flex items-center gap-1"><MapPin className="h-3 w-3" /> This address is saved on the document and remains unchanged if the party master address changes later.</p>
    </div>
  );
}
